import { gql } from '../../__generated__';

export default gql(`
  mutation DeleteIntegration($id: ID!) {
    deleteIntegration(id: $id) {
      id
      ...Integrations
    }
  }
`);
